<span style="white-space: nowrap">
  Date range
  <select class="form-control" [(ngModel)]="gridFilter.periodNo" (keydown.enter)="refreshData()" style="display: inline; margin-right: 5px; width: 130px">
    <option value="-1">Quarter 1</option>
    <option value="-2">Quarter 2</option>
    <option value="-3">Quarter 3</option>
    <option value="-4">Quarter 4</option>
    <option value="13">This year</option>
    <option value="14">Last year</option>
    <option value="15">Custom dates</option>
    <option value="1">January</option>
    <option value="2">February</option>
    <option value="3">March</option>
    <option value="4">April</option>
    <option value="5">May</option>
    <option value="6">June</option>
    <option value="7">July</option>
    <option value="8">August</option>
    <option value="9">September</option>
    <option value="10">October</option>
    <option value="11">November</option>
    <option value="12">December</option>
  </select>
  <select class="form-control" [(ngModel)]="gridFilter.reportYear" (keydown.enter)="refreshData()" style="display: inline; margin-right: 5px; width: 85px" [hidden]="gridFilterPeriodNo() > 12">
    <option value="2019">2019</option>
    <option value="2020">2020</option>
    <option value="2021">2021</option>
    <option value="2022">2022</option>
    <option value="2023">2023</option>
    <option value="2024">2024</option>
    <option value="2025">2025</option>
    <option value="2026">2026</option>
    <option value="2027">2027</option>
    <option value="2028">2028</option>
    <option value="2029">2029</option>
  </select>
</span>
<span style="white-space: nowrap" [hidden]="gridFilter.periodNo != '15'">
  From
  <input type="date" [ngModel]="gridFilter.fromDate | date:'yyyy-MM-dd'" (ngModelChange)="gridFilter.fromDate = $event" maxlength="45" (keydown.enter)="refreshData()" class="form-control" style="display: inline; width: 157px" trimOnBlur>
</span>
<span style="white-space: nowrap" [hidden]="gridFilter.periodNo != '15'">
  To
  <input type="date" [ngModel]="gridFilter.toDate | date:'yyyy-MM-dd'" (ngModelChange)="gridFilter.toDate = $event" maxlength="45" (keydown.enter)="refreshData()" class="form-control" style="display: inline; margin-right: 5px; width: 157px" trimOnBlur>
</span>
&nbsp;&nbsp;
